module.exports = __webpack_public_path__ + "static/media/view1.aa2e9b3b.jpg";